// import React, { useState } from "react";
// import { Modal, Input, message, Spin, Image, Select } from "antd";
// import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
// import api from "../../context/api";
// import BannerImageUploader from "../imageUploader/BannerImageUploader";
// import "./bannercard.scss";

// const { Option } = Select;

// const BannerCard = ({ banner, onUpdate }) => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editMode, setEditMode] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [isHovered, setIsHovered] = useState(false);

//   const [formData, setFormData] = useState({
//     title_uz: banner.title_uz,
//     title_ru: banner.title_ru,
//     title_en: banner.title_en || "",
//     imageFile: banner.image,
//     link_type: banner.link_type,
//     link_target: banner.link_target,
//     is_active: banner.is_active,
//   });

//   const deleteBanner = async () => {
//     setLoading(true);
//     try {
//       await api.delete(`/banner/${banner.id}`);
//       message.success("Banner muvaffaqiyatli o'chirildi");
//       onUpdate();
//     } catch (error) {
//       console.error("Delete error:", error);
//       message.error(error.response?.data?.message || "Bannerni o'chirishda xatolik yuz berdi");
//     } finally {
//       setLoading(false);
//       setIsModalOpen(false);
//     }
//   };

//   const updateBanner = async () => {
//     setLoading(true);
//     const formDataToSend = new FormData();

//     Object.entries(formData).forEach(([key, value]) => {
//       if (value !== null && value !== undefined) {
//         formDataToSend.append(key, value);
//       }
//     });

//     if (formData.imageFile && typeof formData.imageFile !== "string") {
//       formDataToSend.append("image", formData.imageFile);
//     }

//     try {
//       await api.patch(`/banner/${banner.id}`, formDataToSend, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       message.success("Banner muvaffaqiyatli yangilandi");
//       onUpdate();
//       setIsModalOpen(false);
//     } catch (error) {
//       console.error("Update error:", error);
//       message.error(error.response?.data?.message || "Bannerni yangilashda xatolik yuz berdi");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleFormChange = (field, value) => {
//     setFormData((prev) => ({ ...prev, [field]: value }));
//   };

//   const handleLinkUrlChange = (value) => {
//     if (value.includes("|")) {
//       handleFormChange("link_type", "category");
//     }
//     handleFormChange("link_target", value); // ✅ '/' QO‘SHILMAYDI
//   };

//   return (
//     <>
//       <div className="service-card">
//         <div className="card-media">
//           <Image src={banner.image} alt={banner.title_uz} preview={false} />
//           <div className="card-actions">
//             <button onClick={() => { setEditMode(true); setIsModalOpen(true); }}>
//               <EditOutlined /> Tahrirlash
//             </button>
//             <button onClick={() => { setEditMode(false); setIsModalOpen(true); }}>
//               <DeleteOutlined /> O'chirish
//             </button>
//           </div>
//         </div>

//         <div className="card-content">
//           <h3>{banner.title_uz}</h3>
//           <p>{banner.link_target}</p>
//           <p>{banner.is_active ? "Faol" : "Faol emas"}</p>
//         </div>
//       </div>

//       <Modal
//         title={editMode ? "Bannerni tahrirlash" : "O'chirishni tasdiqlang"}
//         open={isModalOpen}
//         onCancel={() => setIsModalOpen(false)}
//         footer={null}
//         width={editMode ? 800 : 520}
//       >
//         <Spin spinning={loading}>
//           {editMode ? (
//             <div className="edit-form">
//               <BannerImageUploader
//                 imageFile={formData.imageFile}
//                 setImageFile={(file) => handleFormChange("imageFile", file)}
//               />

//               <Input
//                 placeholder="Sarlavha (O'zbekcha)"
//                 value={formData.title_uz}
//                 onChange={(e) => handleFormChange("title_uz", e.target.value)}
//               />
//               <Input
//                 placeholder="Sarlavha (Ruscha)"
//                 value={formData.title_ru}
//                 onChange={(e) => handleFormChange("title_ru", e.target.value)}
//               />
//               <Input
//                 placeholder="Sarlavha (Inglizcha)"
//                 value={formData.title_en}
//                 onChange={(e) => handleFormChange("title_en", e.target.value)}
//               />

//               <Select
//                 value={formData.link_type}
//                 onChange={(value) => handleFormChange("link_type", value)}
//               >
//                 <Option value="category">Kategoriya</Option>
//                 <Option value="external">Tashqi havola</Option>
//               </Select>

//               <Input
//                 placeholder="Havola manzili yoki categoriya uchun '4|Ronaldo'"
//                 value={formData.link_target}
//                 onChange={(e) => handleLinkUrlChange(e.target.value)}
//               />

//               <Select
//                 value={formData.is_active}
//                 onChange={(value) => handleFormChange("is_active", value)}
//               >
//                 <Option value={true}>Ha</Option>
//                 <Option value={false}>Yo'q</Option>
//               </Select>

//               <div style={{ marginTop: "20px", textAlign: "right", display: "flex", gap: "12px", justifyContent: "flex-end",transform: `translateX(-15px)`, }}>
//   <button
//     onClick={() => setIsModalOpen(false)}
//     style={{
//       padding: "12px 24px",
//       borderRadius: "8px",
//       backgroundColor: "#f5f5f5",
//       color: "#333",
//       fontSize: "16px",
//       fontWeight: "500",
//       border: "1px solid #d9d9d9",
//       cursor: "pointer",
//       transition: "all 0.3s ease",
//     }}
//     onMouseOver={(e) => {
//       e.target.style.backgroundColor = "#e6e6e6";
//     }}
//     onMouseOut={(e) => {
//       e.target.style.backgroundColor = "#f5f5f5";
//     }}
//   >
//     Bekor qilish
//   </button>

//   <button
//     onClick={updateBanner}
//     style={{
//       padding: "12px 24px",
//       borderRadius: "8px",
//       backgroundColor: "#1890ff",
//       color: "#fff",
//       fontSize: "16px",
//       fontWeight: "500",
//       border: "none",
//       cursor: "pointer",
//       boxShadow: "0 4px 10px rgba(24, 144, 255, 0.3)",
//       transition: "all 0.3s ease",
//     }}
//     onMouseOver={(e) => {
//       e.target.style.backgroundColor = "#40a9ff";
//     }}
//     onMouseOut={(e) => {
//       e.target.style.backgroundColor = "#1890ff";
//     }}
//   >
//     Saqlash
//   </button>
// </div>

//             </div>
//           ) : (
//             <div className="delete-confirmation">
//               <p>Ushbu bannerni o'chirishni istaysizmi?</p>
//               <button onClick={deleteBanner}>O'chirish</button>
//             </div>
//           )}
//         </Spin>
//       </Modal>
//     </>
//   );
// };

// export default BannerCard;


import React, { useState, useEffect } from "react";
import { Modal, Input, message, Spin, Image, Select } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import api from "../../context/api";
import BannerImageUploader from "../imageUploader/BannerImageUploader";
import "./bannercard.scss";

const { Option } = Select;

const BannerCard = ({ banner, onUpdate, categories }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentCategory, setCurrentCategory] = useState(null);
  const [categoryLoading, setCategoryLoading] = useState(false);

  const [formData, setFormData] = useState({
    title_uz: banner.title_uz,
    title_ru: banner.title_ru,
    title_en: banner.title_en || "",
    imageFile: banner.image,
    link_type: banner.link_type,
    link_target: banner.link_target,
    is_active: banner.is_active,
  });

  useEffect(() => {
    if (banner.link_type === 'category') {
      const category = categories.find(c => c.id === parseInt(banner.link_target));
      setCurrentCategory(category);
    }
  }, [banner, categories]);

  const deleteBanner = async () => {
    setLoading(true);
    try {
      await api.delete(`/banner/${banner.id}`);
      message.success("Banner muvaffaqiyatli o'chirildi");
      onUpdate();
    } catch (error) {
      console.error("O'chirishda xatolik:", error);
      message.error(error.response?.data?.message || "Bannerni o'chirishda xatolik yuz berdi");
    } finally {
      setLoading(false);
      setIsModalOpen(false);
    }
  };

  const updateBanner = async () => {
    setLoading(true);
    const formDataToSend = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        if (key === 'link_target' && formData.link_type === 'category' && currentCategory) {
          formDataToSend.append(key, currentCategory.id.toString());
        } else if (key !== 'link_target' || formData.link_type !== 'category') {
          formDataToSend.append(key, value);
        }
      }
    });

    if (formData.imageFile && typeof formData.imageFile !== "string") {
      formDataToSend.append("image", formData.imageFile);
    }

    try {
      await api.patch(`/banner/${banner.id}/`, formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      message.success("Banner muvaffaqiyatli yangilandi");
      onUpdate();
      setIsModalOpen(false);
    } catch (error) {
      console.error("Yangilashda xatolik:", error.response?.data);
      message.error(error.response?.data?.message || "Bannerni yangilashda xatolik yuz berdi");
    } finally {
      setLoading(false);
    }
  };

  const handleFormChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const generateCategoryUrl = (lang) => {
    if (!currentCategory) return '#';
    
    const categoryName = {
      uz: encodeURIComponent(currentCategory.name_uz),
      ru: encodeURIComponent(currentCategory.name_ru),
      en: encodeURIComponent(currentCategory.name_en || currentCategory.name_uz)
    }[lang];

    const langPrefix = lang === 'uz' ? '' : `${lang}/`;
    return `/${langPrefix}products-list?categoryId=${currentCategory.id}&categoryName=${categoryName}`;
  };

  return (
    <>
      <div className="banner-card">
        <div className="card-media">
          <Image src={banner.image} alt={banner.title_uz} preview={false} />
          <div className="card-actions">
            <button onClick={() => { setEditMode(true); setIsModalOpen(true); }}>
              <EditOutlined /> Tahrirlash
            </button>
            <button onClick={() => { setEditMode(false); setIsModalOpen(true); }}>
              <DeleteOutlined /> O'chirish
            </button>
          </div>
        </div>

        <div className="card-content">
          <h3>{banner.title_uz}</h3>
          <div className="link-container">
            {banner.link_type === 'category' ? (
              <Spin spinning={!currentCategory}>
                <div className="category-links">
                  <a href={generateCategoryUrl('uz')} target="_blank" rel="noopener noreferrer">
                    O'zbekcha havola
                  </a>
                  <a href={generateCategoryUrl('ru')} target="_blank" rel="noopener noreferrer">
                    Русская ссылка
                  </a>
                  <a href={generateCategoryUrl('en')} target="_blank" rel="noopener noreferrer">
                    English link
                  </a>
                </div>
                {currentCategory && <span>({currentCategory.name_uz})</span>}
              </Spin>
            ) : (
              <a href={banner.link_target} target="_blank" rel="noopener noreferrer">
                {banner.link_target}
              </a>
            )}
          </div>
          <p className={`status ${banner.is_active ? 'active' : 'inactive'}`}>
            {banner.is_active ? "Faol" : "Faol emas"}
          </p>
        </div>
      </div>

      <Modal
        title={editMode ? "Bannerni tahrirlash" : "O'chirishni tasdiqlang"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={editMode ? 800 : 520}
      >
        <Spin spinning={loading || categoryLoading}>
          {editMode ? (
            <div className="edit-form">
              <BannerImageUploader
                imageFile={formData.imageFile}
                setImageFile={(file) => handleFormChange("imageFile", file)}
              />

              <Input
                placeholder="Sarlavha (O'zbekcha)"
                value={formData.title_uz}
                onChange={(e) => handleFormChange("title_uz", e.target.value)}
                style={{ marginBottom: 16 }}
              />
              <Input
                placeholder="Sarlavha (Ruscha)"
                value={formData.title_ru}
                onChange={(e) => handleFormChange("title_ru", e.target.value)}
                style={{ marginBottom: 16 }}
              />
              <Input
                placeholder="Sarlavha (Inglizcha)"
                value={formData.title_en}
                onChange={(e) => handleFormChange("title_en", e.target.value)}
                style={{ marginBottom: 16 }}
              />

              <Select
                value={formData.link_type}
                onChange={(value) => {
                  handleFormChange("link_type", value);
                  if (value === 'external') {
                    setCurrentCategory(null);
                  }
                }}
                style={{ width: '100%', marginBottom: 16 }}
              >
                <Option value="category">Kategoriya</Option>
                <Option value="external">Tashqi havola</Option>
              </Select>

              {formData.link_type === 'category' && (
                <Select
                  showSearch
                  placeholder="Kategoriyani tanlang"
                  value={currentCategory?.id}
                  onChange={(value) => {
                    const category = categories.find(c => c.id === value);
                    setCurrentCategory(category);
                  }}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  style={{ width: '100%', marginBottom: 16 }}
                >
                  {categories.map(cat => (
                    <Option key={cat.id} value={cat.id}>
                      {cat.name_uz}
                    </Option>
                  ))}
                </Select>
              )}

              {formData.link_type !== 'category' && (
                <Input
                  placeholder="Havola manzili"
                  value={formData.link_target}
                  onChange={(e) => handleFormChange("link_target", e.target.value)}
                  style={{ marginBottom: 16 }}
                />
              )}

              <Select
                value={formData.is_active}
                onChange={(value) => handleFormChange("is_active", value)}
                style={{ width: '100%', marginBottom: 16 }}
              >
                <Option value={true}>Faol</Option>
                <Option value={false}>Faol emas</Option>
              </Select>

              <div className="form-actions">
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="cancel-btn"
                >
                  Bekor qilish
                </button>
                <button
                  onClick={updateBanner}
                  className="submit-btn"
                >
                  Saqlash
                </button>
              </div>
            </div>
          ) : (
            <div className="delete-confirmation">
              <p>Haqiqatan ham ushbu bannerni o'chirmoqchimisiz?</p>
              <div className="confirmation-actions">
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="cancel-btn"
                >
                  Bekor qilish
                </button>
                <button
                  onClick={deleteBanner}
                  className="delete-btn"
                >
                  O'chirish
                </button>
              </div>
            </div>
          )}
        </Spin>
      </Modal>
    </>
  );
};

export default BannerCard;